<template>
  <div id="login-view">
    <button id="login-button" @click="login()">login</button>
    <button id="logout-button" @click="login()">logout</button>
  </div>
  <div>
    <div>logged in: {{ loggedIn }}</div>
  </div>
</template>

<script>
import { userManager, signOutRedirect } from "../../oidc.js";
import { Auth } from 'aws-amplify';

export default {
  name: 'LoginView',
  data () {
    return {
      email: null,
      accessToken: null,
      idToken: null,
      refreshToken: null,
      loggedIn: false
    }
  },
  methods: {
    async login () {
      await userManager.signinRedirect();
    },
    async logout () {
      await signOutRedirect();
    },
    async getUsername() {
      const user = await Auth.currentAuthenticatedUser();
      const username = user.username;

      console.log(username);
    }
  },
  mounted () {
    userManager.signinCallback().then(user => {
      this.email = user.profile?.email;
      this.accessToken = user.access_token;
      this.idToken = user.id_token;
      this.refreshToken = user.refresh_token;

      this.loggedIn = true;

      this.getUsername();
    });
  }
}
</script>